export const TASK_KEY = {
    tasks: '/tasks',
    taskComplete: '/task/complete',
    updateLoadingTask: '/task/update-loading-task',
    checkTaskCode: '/task/check-task-code',
    winners: '/winners',
}
